import {
  ButtonContainer,
  MobileProfileWrapper,
  MobileSettingsWrapper,
  SettingsControlsWrapper,
  Subtitle,
  TransparentProfileImageWrapper,
  TzItem,
  TzList,
} from 'widgets/profile/ui/styles.ts';
import {ProfileHeader} from 'widgets/profile/ui/ui/ProfileHeader.tsx';
// import {ApiariesPicker} from "widgets/hud/ui/ApiariesPicker";
import {EditProfileNav} from 'widgets/profile/ui/ui/EditProfileNav.tsx';
import {SettingsTitle, StyledSectionHeader} from './styles.ts';
import {ProfileButton} from 'widgets/profile/ui/ui/Button.tsx';
import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import {AddLarge, ChevronRightIcon, CloseIcon} from 'shared/ui/icons';
import {useState} from 'react';
import {SETTINGS_BUTTONS, SUPPORT_BTN} from 'widgets/profile/lib/buttons.ts';
import {ProfileInfo} from 'widgets/profile/ui/ProfileSection/ProfileInfo.tsx';
import {ProfileInfoControls} from 'widgets/profile/ui/ui/ProfileInfoControls.tsx';
import {ProfileEditor} from 'widgets/profile/ui/ProfileSection/ProfileEditor.tsx';
import {PasswordEditor} from 'widgets/profile/ui/PasswordSection/PasswordEditor.tsx';
import {ThemeController} from 'widgets/profile/ui/SettingsSection/ThemeController.tsx';
import {logout, toRem} from 'shared/helpers';
import {useUserStore} from 'entities/user';
import userImg from 'assets/img/user.png';
import {ApiariesSelect} from 'widgets/hud/ui/ApiariesSelect/ApiariesSelect.tsx';
import DictionariesContent from 'widgets/profile/ui/ui/DictionariesContent.tsx';
import {NAME_DICTIONARIES} from 'shared/consts/common.ts';
import {ContactContent} from 'widgets/profile/ui/ui/ContactContent.tsx';
import {useUniqueDictionaries} from '../lib/useUniqueDictionaries.ts';
import {useDictionariesStore} from 'entities/dictionaries/index.ts';
import {VetisContent} from './ui/VetisContent.tsx';
import {useTimezoneUpdate} from 'widgets/profile/lib/useTimezoneUpdate.ts';

type ActiveSection =
  | 'profileInfo'
  | 'profilePass'
  | 'themeSettings'
  | 'dictionarySettings'
  | 'support'
  | 'vetisSection'
  | 'timezoneSettings'
  | null;

const SectionHeader = ({title, handleClick}: {title?: string; handleClick: () => void}) => (
  <StyledSectionHeader>
    <SettingsTitle>{title}</SettingsTitle>
    <Button
      iconPrefix={<CloseIcon />}
      variant="secondary"
      colorScheme="neutral"
      style={{
        width: toRem(24),
      }}
      size="s"
      onClick={handleClick}
    />
  </StyledSectionHeader>
);

export const MobileSettings = () => {
  const [activeSection, setActiveSection] = useState<ActiveSection>(null);
  const [showEditor, changeShowEditor] = useState(false);
  const userInfo = useUserStore((s) => s.userInfo);
  const dictionaries = useDictionariesStore((s) => s.dictionaries);
  const openAddModal = useDictionariesStore((s) => s.openAddModal);

  const {selectedDictionary, setSelectedDictionary, uniqueDictionaries} = useUniqueDictionaries(
    dictionaries,
    true
  );
  const {activeTz, timezones, handleTimezoneChange} = useTimezoneUpdate();

  const avatarId = userInfo?.profile?.avatar?.id;
  const imgSrc = avatarId ? `/ecpp/attachments/files?attachmentId=${avatarId}` : userImg;
  const imgAlt = avatarId ? `attachment_${avatarId}` : 'Profile icon';

  if (activeSection === null)
    return (
      <MobileSettingsWrapper>
        <TransparentProfileImageWrapper>
          <img src={imgSrc} alt={imgAlt} height={84} width={84} />
          <>
            <SettingsTitle>
              {userInfo?.name.first} {userInfo?.name.last}
            </SettingsTitle>
            <Subtitle>{userInfo?.credentials.email}</Subtitle>
          </>
        </TransparentProfileImageWrapper>
        <ApiariesSelect />
        {/* <ApiariesPicker /> */}

        <EditProfileNav activeSection={activeSection} setActiveSection={setActiveSection} />
        <SettingsControlsWrapper>
          {SETTINGS_BUTTONS.map((item) => (
            <ProfileButton
              isActive={item.id === activeSection}
              item={item}
              key={item.id}
              aria-label={item.label}
              onClick={() => setActiveSection(item.id as 'themeSettings' | 'dictionarySettings')}
            />
          ))}
        </SettingsControlsWrapper>
        <SettingsControlsWrapper>
          <ProfileButton
            isActive={SUPPORT_BTN.id === activeSection}
            item={SUPPORT_BTN}
            key={SUPPORT_BTN.id}
            aria-label={SUPPORT_BTN.label}
            onClick={() => setActiveSection(SUPPORT_BTN.id as 'support')}
          />
        </SettingsControlsWrapper>
        <Button
          label={'Выйти из аккаунта'}
          style={{
            background: 'transparent',
            marginTop: '16px',
            height: '48px',
          }}
          variant={'secondary'}
          size={'m'}
          onClick={() => logout()}
        />
      </MobileSettingsWrapper>
    );

  if (activeSection === 'timezoneSettings') {
    return (
      <MobileSettingsWrapper>
        <SectionHeader title="Выбор часового пояса" handleClick={() => setActiveSection(null)} />
        <TzList>
          <TzItem
            key={'Автоопределение'}
            $active={null === activeTz}
            onClick={() => handleTimezoneChange(null)}
            type="button"
          >
            {'Автоопределение'}
          </TzItem>
          {timezones.map((it, ind) => (
            <TzItem
              key={ind}
              $active={it.id === activeTz}
              onClick={() => handleTimezoneChange(it.id)}
              type="button"
            >
              {it.label}
            </TzItem>
          ))}
        </TzList>
      </MobileSettingsWrapper>
    );
  }

  if (activeSection === 'profileInfo')
    return (
      <MobileSettingsWrapper>
        <SectionHeader title="Личные данные" handleClick={() => setActiveSection(null)} />
        <ProfileHeader />
        {showEditor ? (
          <MobileProfileWrapper>
            <ProfileEditor changeShowEditor={changeShowEditor} />
          </MobileProfileWrapper>
        ) : (
          <>
            <ProfileInfo />
            <ProfileInfoControls
              isDisabled={false} // todo fix it
              showEditor={showEditor}
              onOpen={() => changeShowEditor(true)}
              onClose={() => changeShowEditor(false)}
              onSubmit={() => {}}
            />
          </>
        )}
      </MobileSettingsWrapper>
    );

  if (activeSection === 'profilePass')
    return (
      <MobileSettingsWrapper>
        <SectionHeader title="Изменение пароля" handleClick={() => setActiveSection(null)} />
        <PasswordEditor onClose={() => setActiveSection(null)} onSubmit={() => {}} />
      </MobileSettingsWrapper>
    );

  if (activeSection === 'themeSettings')
    return (
      <MobileSettingsWrapper>
        <SectionHeader title="Тема оформления" handleClick={() => setActiveSection(null)} />
        <ThemeController controllerType={'radio'} />
      </MobileSettingsWrapper>
    );

  if (activeSection === 'dictionarySettings') {
    if (selectedDictionary === null) {
      return (
        <MobileSettingsWrapper>
          <SectionHeader title="Словари" handleClick={() => setActiveSection(null)} />
          <SettingsControlsWrapper style={{marginTop: 8}}>
            {uniqueDictionaries.map((el) => (
              <ButtonContainer
                key={String(el.type)}
                $active={false}
                $isMobileMenu={false}
                onMouseDown={(e) => e.stopPropagation()}
                onClick={() => setSelectedDictionary(el)}
                style={{width: '100%'}}
              >
                {NAME_DICTIONARIES[el.type] ?? el.type}
                <ChevronRightIcon />
              </ButtonContainer>
            ))}
          </SettingsControlsWrapper>
          <Button
            colorScheme="accent"
            size="l"
            variant="primary"
            iconPrefix={<AddLarge fill={'#ffff'} />}
            style={{
              position: 'fixed',
              bottom: '81px',
              right: '16px',
            }}
            onClick={() => openAddModal()}
          />
        </MobileSettingsWrapper>
      );
    }

    const meta = uniqueDictionaries.find((d) => d.type === selectedDictionary.type);
    return (
      <MobileSettingsWrapper>
        <SectionHeader
          title={meta ? (NAME_DICTIONARIES[meta.type] ?? meta?.type) : ''}
          handleClick={() => setSelectedDictionary(null)}
        />
        <DictionariesContent dictionaryType={selectedDictionary} />
      </MobileSettingsWrapper>
    );
  }

  if (activeSection === 'support')
    return (
      <MobileSettingsWrapper>
        <SectionHeader title="Поддержка" handleClick={() => setActiveSection(null)} />
        <ContactContent isMobile={true} />
      </MobileSettingsWrapper>
    );

  if (activeSection === 'vetisSection')
    return (
      <MobileSettingsWrapper>
        <SectionHeader title="Интеграция с ФГИС" handleClick={() => setActiveSection(null)} />
        <VetisContent />
      </MobileSettingsWrapper>
    );
};
